import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
const spaceXLarge = 'var(--spacing-1-5x, 1.5rem)'
const spaceLarge = 'var(--spacing-1x, 1rem)'
import { useSelector } from 'react-redux'
import { OnetrustSettingsButton } from '@calendly/onetrust/redux'
import { useFlag } from '@calendly/feature-check-react'
import { EventLocation } from '@calendly/booking-kit'
import { BodyText } from '@calendly/ui/components/typography'
import { Loader } from '@calendly/ui/components/loader'

import { useI18n } from 'locales'
import PaymentSummary from 'components/payment/summary'
import { Links } from 'components/confirmation/links'
import { BookingRedesignLegalFooter } from 'components/layout/booking_redesign_legal_footer'
import Signup from 'components/signup'
import { Input, Title as SignupTitle } from 'components/signup/styles'
import Details from 'components/details'
import Marker from 'components/details/marker'
import EventTime from 'components/details/event_time'
import Timezone from 'components/details/timezone'
import Attendees from 'components/details/attendees'
import PaymentMessage from 'components/confirmation/payment_message'
import { timeNotationSelector, eventSelector } from 'selectors'
import { emailSelector } from 'selectors/invitee'
import { currentUserSelector } from 'selectors/user'
import Profile from 'components/profile'
import { notificationTypeSelector } from 'selectors/scheduling'
import { useInvitee } from 'components/use_invitee'
import ErrorAlert from 'components/error/alert'
import { eventTypeSelector } from 'root-api'

import { PollCreationCallToAction } from './poll_creation_call_to_action'
import _FooterContainer from "layout-FooterContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=FooterContainer";
import _Payment from "layout-Payment.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=Payment";
import _Header from "layout-Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=Header";
import _DetailsWrapper from "layout-DetailsWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=DetailsWrapper";
import _Container from "layout-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=Container";
import _LegacyCookieSettingsButton from "layout-LegacyCookieSettingsButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=LegacyCookieSettingsButton";
import _RedesignLegalFooterContainer from "layout-RedesignLegalFooterContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=RedesignLegalFooterContainer";
import _StyledSignUp from "layout-StyledSignUp.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=StyledSignUp";
import _StyledPollConfirmationFooter from "layout-StyledPollConfirmationFooter.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=StyledPollConfirmationFooter";
import _EmailMessageContainer from "layout-EmailMessageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=EmailMessageContainer";


const FooterContainer = /*#__PURE__*/styled('div', null, {
  displayName: "FooterContainer",
  styles: _FooterContainer
})

const Payment = /*#__PURE__*/styled(PaymentSummary, null, {
  displayName: "Payment",
  styles: _Payment
})

const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

export const DetailsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "DetailsWrapper",
  styles: _DetailsWrapper
})

export const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const LegacyCookieSettingsButton = /*#__PURE__*/styled(OnetrustSettingsButton, null, {
  displayName: "LegacyCookieSettingsButton",
  styles: _LegacyCookieSettingsButton
})

const RedesignLegalFooterContainer = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignLegalFooterContainer",
  styles: _RedesignLegalFooterContainer
})

export const ConfirmationRedesignFooterSection = () => (
  <RedesignLegalFooterContainer>
    <BookingRedesignLegalFooter />
  </RedesignLegalFooterContainer>
)

export const CookieSettingsButton = ({ className } = {}) => {
  const isTabletDown = useDeviceType('isTabletDown')
  const isDesktopUp = useDeviceType('isDesktopUp')

  return <LegacyCookieSettingsButton isTabletDown={isTabletDown} isDesktopUp={isDesktopUp} className={className} />
}

const StyledSignUp = /*#__PURE__*/styled(Signup, null, {
  displayName: "StyledSignUp",
  styles: _StyledSignUp
})

export const ConfirmationFooter = ({ className, isPoll, isReconfirmation = false }) => {
  const currentUser = useSelector(currentUserSelector)
  const eventType = useSelector(eventTypeSelector)
  if (!eventType) return null

  return (
    <FooterContainer data-component="confirmation-footer" className={className}>
      <Links isReconfirmation={isReconfirmation} />
      {!eventType.unbranded && !currentUser && <StyledSignUp isPoll={isPoll} />}
      {!eventType.unbranded && currentUser && isPoll && <PollCreationCallToAction />}
    </FooterContainer>
  )
}

const StyledPollConfirmationFooter = /*#__PURE__*/styled(ConfirmationFooter, null, {
  displayName: "StyledPollConfirmationFooter",
  styles: _StyledPollConfirmationFooter
})

export const PollConfirmationFooter = (props) => {
  const isTabletUp = useDeviceType('isTabletUp')

  return <StyledPollConfirmationFooter isTabletUp={isTabletUp} isPoll {...props} />
}

const EmailMessageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "EmailMessageContainer",
  styles: _EmailMessageContainer
})

const EmailConfirmationMessage = () => {
  const { i18n } = useI18n()
  return (
    <EmailMessageContainer>
      <BodyText weight="bold">
        {i18n.t('booking.templates.email_confirmation_message')}
      </BodyText>
    </EmailMessageContainer>
  )
}

export const ConfirmationDetails = () => {
  const event = useSelector(eventSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const { timezone, charge, email } = useInvitee()
  const isEmailConfirmation = useSelector(notificationTypeSelector) === 'email'
  const inviteeEmail = useSelector(emailSelector)
  const sniperLinkFeatureActive = useFlag('sb_sniper_links_feature', false)
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const shouldSeeGmailSniperLink = inviteeEmail && inviteeEmail.includes('@gmail.com') && sniperLinkFeatureActive

  if (event === undefined) return <Loader />

  if (event === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  const {
    color, name, guests
  } = event

  return (
    <div>
      <Details bookingAppRedesign={bookingAppRedesign}>
        <Marker color={color} text={name} bookingAppRedesign={bookingAppRedesign} />
        <EventTime
          source={event}
          timezone={timezone}
          timeNotation={timeNotation}
          bookingAppRedesign={bookingAppRedesign}
        />
        <Timezone value={timezone} bookingAppRedesign={bookingAppRedesign} />
        <EventLocation event={event} iconSize={bookingAppRedesign ? 'standard' : 'large'} />
        <Attendees items={[email, ...guests]} bookingAppRedesign={bookingAppRedesign} />
      </Details>
      <Payment charge={charge} />
      {!shouldSeeGmailSniperLink && <PaymentMessage />}
      {isEmailConfirmation && <EmailConfirmationMessage />}
    </div>
  )
}

export const ConfirmationHeader = ({ children }) => {
  const event = useSelector(eventSelector)
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  if (event === undefined) return <Loader />

  if (event === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  const {
    scheduled_profile: {
      avatar_url: avatarUrl,
      logo_url: logoUrl
    }
  } = event

  return (
    <Header bookingAppRedesign={bookingAppRedesign} data-component="confirmation-header">
      <Profile
        avatar={avatarUrl}
        logoUrl={logoUrl}
      />
      {children}
    </Header>
  )
}
